import { render, staticRenderFns } from "./CompCompetitionsRewards.vue?vue&type=template&id=265c6c40&scoped=true"
import script from "./CompCompetitionsRewards.vue?vue&type=script&setup=true&lang=js"
export * from "./CompCompetitionsRewards.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompCompetitionsRewards.vue?vue&type=style&index=0&id=265c6c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265c6c40",
  null
  
)

export default component.exports